import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'STUDIO SESSIONS', path: '/studio-sessions' },
  { label: 'VIDEO SERVICES', path: '/video-services' },
  { label: 'PORTFOLIO', path: '/portfolio' },
  { label: 'ABOUT', path: '/about' },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleBookClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === '/studio-sessions') {
      const element = document.getElementById('booking-engine');
      if (element) {
        const headerOffset = 72;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    } else {
      navigate('/studio-sessions', { state: { scrollToBooking: true } });
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#000000] border-b border-neutral-800 transition-colors duration-150">
        <div className="h-[72px] px-5 md:px-12 flex items-center justify-between">

          {/* Brand Lockup */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center group transition-all duration-150 ease-in-out hover:opacity-80">
              <span className="text-white font-black text-xl tracking-tighter">BA</span>
              <span className="h-4 w-[1px] bg-neutral-700 mx-3 inline-block"></span>
              <span className="text-[11px] font-black tracking-[0.2em] text-white uppercase hidden sm:inline-block">
                BAY AREA PODCAST STUDIO
              </span>
            </Link>
          </div>

          {/* Desktop Nav Links */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map(({ label, path }) => (
              <Link
                key={label}
                to={path}
                className="text-xs font-bold uppercase tracking-[0.15em] text-white hover:text-neutral-300 transition-all duration-150 ease-in-out"
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* Right Side: CTA + Hamburger */}
          <div className="flex items-center gap-4">
            <a
              href="/studio-sessions"
              onClick={handleBookClick}
              className="hidden sm:inline-block bg-white text-black font-bold text-xs uppercase tracking-[0.15em] px-5 py-3 border border-white hover:bg-black hover:text-white transition-all duration-150 ease-in-out text-center cursor-pointer"
            >
              BOOK THE STUDIO
            </a>

            {/* Hamburger */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle navigation menu"
              className="md:hidden flex flex-col justify-center items-center w-10 h-10 gap-[5px] focus:outline-none"
            >
              <span className={`block h-[2px] bg-white transition-all duration-300 ease-in-out ${menuOpen ? 'w-6 rotate-45 translate-y-[7px]' : 'w-6'}`}></span>
              <span className={`block h-[2px] bg-white transition-all duration-300 ease-in-out ${menuOpen ? 'w-6 opacity-0' : 'w-4'}`}></span>
              <span className={`block h-[2px] bg-white transition-all duration-300 ease-in-out ${menuOpen ? 'w-6 -rotate-45 -translate-y-[7px]' : 'w-6'}`}></span>
            </button>
          </div>

        </div>
      </header>

      {/* Mobile Fullscreen Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black flex flex-col transition-all duration-300 ease-in-out md:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ paddingTop: '72px' }}
      >
        <nav className="flex flex-col flex-1 justify-center items-center gap-8 px-8">
          {navLinks.map(({ label, path }) => (
            <Link
              key={label}
              to={path}
              className="text-white font-black text-2xl uppercase tracking-[0.15em] hover:text-neutral-400 transition-colors duration-150"
            >
              {label}
            </Link>
          ))}

          {/* Book CTA inside mobile menu */}
          <a
            href="/studio-sessions"
            onClick={handleBookClick}
            className="mt-4 bg-white text-black font-bold text-sm uppercase tracking-[0.15em] px-10 py-4 w-full max-w-xs text-center border border-white hover:bg-neutral-200 transition-colors duration-150 cursor-pointer"
          >
            BOOK THE STUDIO
          </a>
        </nav>

        <p className="text-neutral-600 text-xs text-center tracking-widest uppercase pb-8">
          Bay Area Podcast Studio — Fremont, CA
        </p>
      </div>
    </>
  );
}